import { useEffect, useState } from 'react';
import { getDefaultYear, loadCsvData } from '../services/csvDataService';

export function useQuillesData(seasonYear = getDefaultYear()) {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		let cancelled = false;
		setData(null);
		(async () => {
			try {
				setLoading(true);
				setError(null);
				const loaded = await loadCsvData(seasonYear);
				if (!cancelled) setData(loaded);
			} catch (err) {
				if (!cancelled) {
					setError(err.message || 'Erreur de chargement des CSV.');
					setData(null);
				}
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => { cancelled = true; };
	}, [seasonYear]);

	return { data, loading, error };
}
